const getCityFromIP = (store) => {
	return store.Session?.ipToCity?.data?.city;
};

export default getCityFromIP;
